import { configureStore } from "@reduxjs/toolkit";
import siteContentReducer from "./redux/siteContentSlice";
import kycReducer from "./redux/kycSlice";
export const store = configureStore({
  reducer: {
    siteContent: siteContentReducer,
    kycContent: kycReducer,
  },
});
